import { useState } from 'react';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import RowContainer from './components/RowContainer';
import RowContent from './components/RowContent';
import SectionTitle from './components/SectionTitle';

interface Props {
  studentGrade: number;
  studentGender: number;
  register: UseFormRegister<FieldValues>;
  isConfirmPassword: boolean;
  onConfirmPassword: () => void;
}

function Contents4(props: Props) {
  const { palette } = useTheme();

  const bloodTest = [
    [
      {
        label: 'CBC - 전혈구계산',
        link: 'https://www.youtube.com/watch?v=8jn5AMIhPlc&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=22',
      },
      {
        label: 'CRP - C반응성 단백검사',
        link: 'https://www.youtube.com/watch?v=oyPp9CYDLfo&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=23',
      },
      {
        label: 'AST/ALT(GOT/GPT) - 간 수치',
        link: 'https://www.youtube.com/watch?v=5TYvzFWD5nA&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=24',
      },
    ],
    [
      {
        label: '알부민 (Albumin)',
        link: 'https://www.youtube.com/watch?v=ii0uEmKczcM&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=25',
      },
      {
        label: 'Amylase, Lipase - 췌장수치',
        link: 'https://www.youtube.com/watch?v=sPZ2_jFzOFk&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=26',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  const takingOver = [
    [
      {
        label: '간경변증(LC) 환자',
        link: 'https://www.youtube.com/watch?v=xxbNcA6Gnt0&list=PLVnfLGLhl7_Cx6TzlDK0bNbqa0E1vq7VH&index=2',
      },
      {
        label: '총담관결석&담관염 환자',
        link: 'https://www.youtube.com/watch?v=u_Gt0Of2aCg&list=PLVnfLGLhl7_Cx6TzlDK0bNbqa0E1vq7VH&index=3',
      },
      {
        label: '완전방실차단, 신부전 환자',
        link: 'https://www.youtube.com/watch?v=lhHoCfIi5pU&list=PLVnfLGLhl7_Cx6TzlDK0bNbqa0E1vq7VH&index=4',
      },
    ],
    [
      {
        label: '협심증 환자, CAG/PCI ',
        link: 'https://www.youtube.com/watch?v=uaq6Wu7yMr8&list=PLVnfLGLhl7_Cx6TzlDK0bNbqa0E1vq7VH&index=5',
      },
      {
        label: '항암화학요법, regimen, cancer',
        link: 'https://www.youtube.com/watch?v=9UPRIGC0l7o&list=PLVnfLGLhl7_Cx6TzlDK0bNbqa0E1vq7VH&index=9',
      },
      {
        label: '울혈성 심부전, 3 vessel disease',
        link: 'https://www.youtube.com/watch?v=IjzQw7CHnhw',
      },
    ],
    [
      {
        label: '알코올 간경화 환자',
        link: 'https://www.youtube.com/watch?v=jSoLAD0uRMk',
      },
      {
        label: '',
        link: '',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  return (
    <Box sx={{ margin: '40px' }}>
      <SectionTitle title="혈액검사" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {bloodTest.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>

      <SectionTitle title="인수인계" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {takingOver.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-end'}
        sx={{ marginTop: '20px', width: '100%' }}
      >
        <Typography sx={{ fontSize: '12px', color: `${palette.primary.main}` }}>
          해당 예시 영상은 알엔지야TV에서 제작되었습니다.
        </Typography>
      </Box>
    </Box>
  );
}

export default Contents4;
